/**
 * IntentCheckboxList.js
 *
 * Renders a list of checkboxes for selecting user intents.
 */
import React from 'react';
import PropTypes from 'prop-types';
import CheckboxField from '@/forms/_fields_v2/CheckboxField';

const INTENT_OPTIONS = [
  { id: 'school_educator', label: 'I teach at a school that serves PreK-12 students' },
  { id: 'org_educator', label: 'I teach PreK-12 students at a youth-serving organization or after-school program' },
  { id: 'community_partner', label: "I'd like to share my skills and knowledge as a community partner." },
];

IntentCheckboxList.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired,
};

/**
 * Component for displaying and selecting user roles/intents.
 *
 * @param {object} props - Component props.
 * @param {Array} props.selected - Currently selected intent IDs.
 * @param {Function} props.onToggle - Callback function to toggle an intent selection.
 * @returns {JSX.Element} The rendered checkbox list.
 */
export default function IntentCheckboxList(props) {
  const { selected, onToggle } = props;
  return (
    <div className="min-w-80 flex flex-col gap-4 mb-12">
      {INTENT_OPTIONS.map((option) => (
        <CheckboxField
          key={option.id}
          label={option.label}
          checked={selected.includes(option.id)}
          onChange={() => onToggle(option.id)}
        />
      ))}
    </div>
  );
}
